import { BitkitIconComponent } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

type ProviderCardProps = {
  name: string;
  icon: BitkitIconComponent;
  isSelected: boolean;
  onClick: () => void;
};

const ProviderCard = ({ name, icon: Icon, isSelected, onClick }: ProviderCardProps) => (
  <Box
    asChild
    display="flex"
    alignItems="center"
    justifyContent="center"
    gap="8"
    height="40"
    paddingInline="12"
    borderRadius="8"
    borderWidth="1"
    borderStyle="solid"
    borderColor="border/regular"
    background="background/primary"
    color={isSelected ? 'text/primary' : 'text/secondary'}
    cursor="pointer"
    outline={isSelected ? '2px solid' : undefined}
    outlineColor={isSelected ? 'border/selected' : undefined}
    outlineOffset={isSelected ? '-2px' : undefined}
    _hover={{ borderColor: 'border/strong' }}
  >
    <button type="button" aria-pressed={isSelected} onClick={onClick}>
      <Icon size="16" />
      <Text textStyle="body/md/semibold" whiteSpace="nowrap">
        {name}
      </Text>
    </button>
  </Box>
);

export default ProviderCard;
